import type { MeResponse, Rolle } from '@ksb/shared';
import type { ReactNode } from 'react';
import { KeinZugriffSeite } from '../pages/KeinZugriffSeite';

/**
 * Blendet Bereiche ohne passende Rolle aus. Das ist nur Komfort: Die eigentliche
 * Berechtigungsprüfung findet immer im Backend statt.
 */
export function RollenGuard({
  benutzer,
  erlaubt,
  children,
}: {
  benutzer: Pick<MeResponse, 'rollen'>;
  erlaubt: Rolle[];
  children: ReactNode;
}) {
  const darf = benutzer.rollen.some((r) => erlaubt.includes(r));
  return darf ? children : <KeinZugriffSeite />;
}
